{
  "MFA_SETTINGS": {
    "TITLE": "İki Faktörlü Kimlik Doğrulama",
    "SUBTITLE": "Protect your account from unauthorized access with TOTP-based authentication. This adds an extra layer of security to your account.",
    "DESCRIPTION": "Zaman tabanlı tek kullanımlık şifre (TOTP) kullanarak hesabınıza ekstra bir güvenlik katmanı ekleyin",
    "STATUS_TITLE": "Kimlik Doğrulama Durumu",
    "STATUS_DESCRIPTION": "İki faktörlü kimlik doğrulama ayarlarınızı ve yedek kurtarma kodlarınızı yönetin",
    "ENABLED": "Etkin",
    "DISABLED": "Devre dışı",
    "STATUS_ENABLED": "İki faktörlü kimlik doğrulama etkin",
    "STATUS_ENABLED_DESC": "Hesabınız ek bir güvenlik katmanı ile korunmaktadır",
    "ENABLE_BUTTON": "İki Faktörlü Kimlik Doğrulamayı Etkinleştir",
    "ENHANCE_SECURITY": "Hesap Güvenliğinizi Artırın",
    "ENHANCE_SECURITY_DESC": "İki faktörlü kimlik doğrulama, şifrenize ek olarak kimlik doğrulama uygulamanızdan bir doğrulama kodu talep ederek ekstra bir güvenlik katmanı ekler.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "Kimlik Doğrulama Uygulamanızla QR Kodunu Tarayın",
      "STEP1_DESCRIPTION": "Google Authenticator, Authy veya TOTP uyumlu herhangi bir uygulamayı kullanın",
      "LOADING_QR": "Loading...",
      "MANUAL_ENTRY": "Tarama yapamıyor musunuz? Kodu manuel olarak girin",
      "SECRET_KEY": "Gizli Anahtar",
      "COPY": "Kopyala",
      "ENTER_CODE": "Doğrulama uygulamanızdan 6 haneli kodu girin",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "Doğrula & Devam Et",
      "CANCEL": "İptal Et",
      "ERROR_STARTING": "MFA etkinleştirilmemiştir. Lütfen yöneticiyle iletişime geçin.",
      "INVALID_CODE": "Geçersiz doğrulama kodu",
      "SECRET_COPIED": "Gizli anahtar panoya kopyalandı",
      "SUCCESS": "İki faktörlü kimlik doğrulama başarıyla etkinleştirildi"
    },
    "BACKUP": {
      "TITLE": "Yedek Kodlarınızı Kaydedin",
      "DESCRIPTION": "Bu kodları güvenli bir yerde saklayın. Kimlik doğrulayıcınıza erişiminizi kaybederseniz, her birini bir kez kullanabilirsiniz.",
      "IMPORTANT": "Önemli:",
      "IMPORTANT_NOTE": " Bu kodları güvenli bir yerde saklayın. Bir daha göremeyeceksiniz.",
      "DOWNLOAD": "İndir",
      "COPY_ALL": "Tümünü Kopyala",
      "CONFIRM": "Yedek kodlarımı güvenli bir yerde kaydettim ve bunları tekrar göremeyeceğimi anlıyorum",
      "COMPLETE_SETUP": "Kurulumu Tamamla",
      "CODES_COPIED": "Yedek kodlar panoya kopyalandı"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "Yedek Kodlar",
      "BACKUP_CODES_DESC": "Mevcut kodlarınızı kaybettiyseniz veya kullandıysanız yeni kodlar oluşturun",
      "REGENERATE": "Yedek Kodları Yeniden Oluştur",
      "DISABLE_MFA": "2FA'yı devre dışı bırak",
      "DISABLE_MFA_DESC": "Hesabınızdan iki faktörlü kimlik doğrulamayı kaldırın",
      "DISABLE_BUTTON": "İki Faktörlü Kimlik Doğrulamayı Devre Dışı Bırak"
    },
    "DISABLE": {
      "TITLE": "İki Faktörlü Kimlik Doğrulamayı Devre Dışı Bırak",
      "DESCRIPTION": "İki faktörlü kimlik doğrulamayı devre dışı bırakmak için şifrenizi ve doğrulama kodunu girmeniz gerekir.",
      "PASSWORD": "Parola",
      "OTP_CODE": "Doğrulama Kodu",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "Yedek Kod",
      "BACKUP_CODE_PLACEHOLDER": "Yedek kodlarınızdan birini girin",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "2FA'yı devre dışı bırak",
      "CANCEL": "İptal Et",
      "SUCCESS": "İki faktörlü kimlik doğrulama devre dışı bırakıldı",
      "ERROR": "MFA devre dışı bırakılamadı. Lütfen kimlik bilgilerinizi kontrol edin."
    },
    "REGENERATE": {
      "TITLE": "Yedek Kodları Yeniden Oluştur",
      "DESCRIPTION": "Bu işlem, mevcut yedek kodlarınızı geçersiz kılacak ve yeni kodlar oluşturacaktır. Devam etmek için doğrulama kodunuzu girin.",
      "OTP_CODE": "Doğrulama Kodu",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "Yeni Kodlar Oluştur",
      "CANCEL": "İptal Et",
      "NEW_CODES_TITLE": "Yeni Yedek Kodlar Oluşturuldu",
      "NEW_CODES_DESC": "Eski yedek kodlarınız geçersiz hale getirilmiştir. Bu yeni kodları güvenli bir yerde saklayın.",
      "CODES_IMPORTANT": "Önemli:",
      "CODES_IMPORTANT_NOTE": " Her kod yalnızca bir kez kullanılabilir. Bu pencereyi kapatmadan önce kodları kaydedin.",
      "DOWNLOAD_CODES": "Kodları İndir",
      "COPY_ALL_CODES": "Tüm Kodları Kopyala",
      "CODES_SAVED": "Kodlarımı Kaydettim",
      "SUCCESS": "Yeni yedek kodlar oluşturuldu",
      "ERROR": "Yedek kodları yeniden oluşturulamadı"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "İki Faktörlü Kimlik Doğrulama",
    "DESCRIPTION": "Devam etmek için doğrulama kodunuzu girin",
    "AUTHENTICATOR_APP": "Kimlik Doğrulama Uygulaması",
    "BACKUP_CODE": "Yedek Kod",
    "ENTER_OTP_CODE": "Doğrulama uygulamasından 6 haneli kodu girin",
    "ENTER_BACKUP_CODE": "Yedek kodlarınızdan birini girin",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "Doğrula",
    "TRY_ANOTHER_METHOD": "Başka bir doğrulama yöntemi deneyin",
    "CANCEL_LOGIN": "İptal et ve giriş sayfasına dön",
    "HELP_TEXT": "Giriş yaparken sorun mu yaşıyorsunuz?",
    "LEARN_MORE": "2FA hakkında daha fazla bilgi edinin",
    "HELP_MODAL": {
      "TITLE": "İki Faktörlü Kimlik Doğrulama Yardımı",
      "AUTHENTICATOR_TITLE": "Kimlik Doğrulama Uygulaması Kullanma",
      "AUTHENTICATOR_DESC": "Kimlik doğrulayıcı uygulamanızı (Google Authenticator, Authy vb.) açın ve hesabınız için gösterilen 6 haneli kodu girin.",
      "BACKUP_TITLE": "Yedek Kod Kullanma",
      "BACKUP_DESC": "Kimlik doğrulayıcı uygulamanıza erişiminiz yoksa, 2FA kurarken kaydettiğiniz yedek kodlardan birini kullanabilirsiniz. Her kod yalnızca bir kez kullanılabilir.",
      "CONTACT_TITLE": "Daha Fazla Yardıma mı İhtiyacınız Var?",
      "CONTACT_DESC_CLOUD": "Hem kimlik doğrulayıcı uygulamanıza hem de yedek kodlarınıza erişiminizi kaybettiyseniz, yardım için Chatwoot destek ekibiyle iletişime geçin.",
      "CONTACT_DESC_SELF_HOSTED": "Hem kimlik doğrulayıcı uygulamanıza hem de yedek kodlarınıza erişiminizi kaybettiyseniz, yardım için yöneticinizle iletişime geçin."
    },
    "VERIFICATION_FAILED": "Doğrulama başarısız oldu. Lütfen tekrar deneyin."
  }
}
